export default "__VITE_ASSET__fb75bc96__"